import { ErrorMessageEn, ErrorMessageEs } from '../../../../constants/alerts';
import { errorHandler } from '../../../utils';
import {
  AddCandidateExtracurricularsInternalInput,
  AddCandidateExtracurricularsInternalOutput,
  CandidateExtracurricularBuilder,
} from '../candidate-extracurricular.types';

export const addCandidateExtracurricularsInternal = (
  builder: CandidateExtracurricularBuilder
) =>
  builder.mutation<
    AddCandidateExtracurricularsInternalOutput,
    AddCandidateExtracurricularsInternalInput
  >({
    query: ({ data, candidateId }) => ({
      url: `/candidate-extracurricular/add-range/internal/${candidateId}`,
      method: 'POST',
      body: data.map((extra) => ({
        Id: extra?.Id,
        ExtracurricularType: extra?.ExtracurricularType.val,
        ExtracurricularDetail: extra?.ExtracurricularDetail.val,
      })),
    }),
    invalidatesTags: [
      { type: 'candidateExtracurriculars', id: 'LIST' },
      'Score',
    ],
    transformErrorResponse: (error, meta, { lang }) => {
      errorHandler(
        '[setExtracurricularsAction]',
        lang === 'es' ? ErrorMessageEs.InfoFail : ErrorMessageEn.InfoFail,
        error,
        true
      );
    },
  });
